import { TransitionGroup } from 'react-transition-group';
import { canValidateOpgavekompleksetTask } from '@utils/component-framework';
import { CSSRefTransition } from '@utils/react';
import { useGoToNextTaskAction } from '../../../state/actions/task.go-to-next.js';
import { useValidateCurrentTaskAction } from '../../../state/actions/task.validate-current.js';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { useCurrentTask } from '../../../state/hook.current-task.js';
import { useCurrentTaskEntryId, useCurrentTaskEntry } from '../../../state/hook.entry.js';
import { makeSelectTaskState } from '../../../state/selectors/task.get-state.js';
import { shouldShowFeedback } from '../../../state/util.should-show-feedback.js';
import { crossfadeWrapper, crossfadeContainer, crossfadeDurationMs, actions, nextButton } from './_actions.style.js';
import { NextButton } from './button.next.js';
import { PrevButton } from './button.prev.js';
import { ValidateButton } from './button.validate.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function FreeProgressionActions() {
  const component = useOpgavekompleksetComponent();
  const withValidation = shouldShowFeedback(component.data.settings.flowType);
  if (withValidation) {
    return /*#__PURE__*/jsx(WithValidation, {});
  } else {
    return /*#__PURE__*/jsx(WithoutValidation, {});
  }
}
function WithValidation() {
  const component = useOpgavekompleksetComponent();
  const currentId = useCurrentTaskEntryId();
  const currentTask = useCurrentTask();
  const goToNextTask = useGoToNextTaskAction();
  const validateCurrentTask = useValidateCurrentTaskAction();
  const taskState = useCurrentTaskEntry({
    select: makeSelectTaskState(component.data)
  });
  const canValidate = canValidateOpgavekompleksetTask(currentTask.task);
  const isLastTask = component.data.tasks.findLastIndex(it => it.id === currentId) === component.data.tasks.length - 1;
  const showValidationButton = taskState === "input" && canValidate;
  return /*#__PURE__*/jsx(TransitionGroup, {
    className: crossfadeWrapper,
    children: /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: crossfadeDurationMs,
      classNames: crossfadeContainer,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: crossfadeContainer,
        children: /*#__PURE__*/jsxs("div", {
          className: actions,
          children: [/*#__PURE__*/jsx(PrevButton, {}), /*#__PURE__*/jsx(NextButton, {
            tooltip: {
              ariaType: "label",
              body: isLastTask ? "Afslut" : "Næste"
            },
            theme: "secondary",
            onClick: goToNextTask,
            label: undefined
          }), showValidationButton ? /*#__PURE__*/jsx(ValidateButton, {
            onClick: validateCurrentTask,
            disabledMessage: taskState !== "input" ? "Du har allerede besvaret denne opgave" : undefined,
            currentTaskId: currentId
          }) : /*#__PURE__*/jsx(NextButton, {
            className: nextButton,
            theme: "primary",
            onClick: goToNextTask,
            disableIcon: true,
            label: isLastTask ? "Afslut" : "Næste"
          })]
        })
      })
    }, `${currentId}${showValidationButton}`)
  });
}
function WithoutValidation() {
  const component = useOpgavekompleksetComponent();
  const currentId = useCurrentTaskEntryId();
  const goToNextTask = useGoToNextTaskAction();
  const isLastTask = component.data.tasks.findLastIndex(it => it.id === currentId) === component.data.tasks.length - 1;
  return /*#__PURE__*/jsx(TransitionGroup, {
    className: crossfadeWrapper,
    children: /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: crossfadeDurationMs,
      classNames: crossfadeContainer,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: crossfadeContainer,
        children: /*#__PURE__*/jsxs("div", {
          className: actions,
          children: [/*#__PURE__*/jsx(PrevButton, {}), /*#__PURE__*/jsx(NextButton, {
            label: isLastTask ? "Se resultat" : "Næste",
            theme: "primary",
            onClick: goToNextTask
          })]
        })
      })
    }, String(isLastTask))
  });
}

export { FreeProgressionActions };
//# sourceMappingURL=integration.free-progression.js.map
